import React from 'react';
import './App.css';
import { Component, createContext, useState, useEffect, useContext, useCallback }  from 'react';
import { Link, Router, useParams } from "@reach/router";
import logos from './logos.svg';
import admin from './admin.png';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import "firebase/auth";
import firebase from "firebase/app";
import Avatar from '@material-ui/core/Avatar';
import explore from './explore.mp4';
import connect from './connect.mp4';
import improve from './improve.mp4';





const useStyles = makeStyles((theme) => ({
    typography: {
      padding: theme.spacing(2),
    },
    root: {
      '& .MuiTextField-root': {
        margin: theme.spacing(1),
        width: '25ch',
        justifyContent: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        alignItems: 'center',
        alignSelf: 'center',
      },
       },
        button: {
      margin: theme.spacing(1),
    },
      modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    media: {
      height: 0,
      paddingTop: '56.25%', // 16:9
    },
    expand: {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
    },
    expandOpen: {
      transform: 'rotate(180deg)',
    },
  
  }));
   

export default function HomePageScreen () {

    function getWindowDimensions() {
        const { innerWidth: width, innerHeight: height } = window;
        return {
          width,
          height
        };
      }
      
       function useWindowDimensions() {
        const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
      
        useEffect(() => {
          function handleResize() {
            setWindowDimensions(getWindowDimensions());
          }
      
          window.addEventListener('resize', handleResize);
          return () => window.removeEventListener('resize', handleResize);
        }, []);
      
        return windowDimensions;
      }
      
      
      
      const { height, width } = useWindowDimensions();

         console.log('home');



    const [navigation, setNavigation] = useState('introduction');

    return (
<div style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', width: '100%'}}>

<div className='Header-home' >
<img className="App-logo" src={logos} onClick={() => setNavigation('introduction')}  />
        <div className="loginbuttons" >
        <h2 style={{fontSize: `calc(4px + 2vmin)`, padding: '2%'}} onClick={() => setNavigation('login')}>Login</h2>
        <p style={{fontSize: `calc(4px + 2vmin)`, padding: '2%', width:"100%"}}  onClick={() => setNavigation('signup')} >Sign Up</p>        </div>
</div>
    

   <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%'}}>

   

<div style={{ display: 'flex',  flexDirection: 'column', justifyContent: 'center', width: '100%' }}>

{ navigation === 'introduction' ? <IntroductionScreen/> : navigation === 'signup' ? <SignUpScreen/> : <LoginScreen/>}


               
</div>
   </div>
   
</div>
        
    )
}



 function LoginScreen () {

        const [loading, setLoading] = useState(true); // Set loading to true on component mount
        const [userss, setUserss] = useState([]); 
        const [data, setData] = useState('');
      
        const [visible, setVisible] = useState(true);
        const [learnershubemail, setLearnershubemail] = useState('');
        const [errors, setErrors] = useState(false);
        const [password, setPassword] = useState('');
      const [errorMessages, setErrorMessages] = useState('no errors');
      const [errorCode, setErrorCode] = useState('no errors');
      

      console.log('login');

      
      
        const provider = new firebase.auth.GoogleAuthProvider();

        const classes = useStyles();

        async function googleSignIn () {

          await firebase.auth().useDeviceLanguage();

            await firebase.auth().signInWithRedirect(provider).then(function(result) {
              // This gives you a Google Access Token. You can use it to access the Google API.
              var token = result.credential.accessToken;
              // The signed-in user info.
              var user = result.user;
              // ...
            }).catch(function(error) {
              // Handle Errors here.
              var errorCode = error.code;
              var errorMessage = error.message;
              // The email of the user's account used.
              var email = error.email;
              // The firebase.auth.AuthCredential type that was used.
              var credential = error.credential;
        
              setErrorMessages(errorMessage);
          setErrorCode(errorCode);
              // ...
            });
          }

       
       
        
  async function CustomSignIn () {

    firebase.auth().signInWithEmailAndPassword(learnershubemail, password).catch(function(error) {
 // Handle Errors here.
 var errorCode = error.code;
 var errorMessage = error.message;
 // ...
 setErrorMessages(errorMessage);
 setErrorCode(errorCode);
});
  }



  
function LoginInstructions () {

    return(
  <div>
  <div style={{width: '100%', height: 'auto',  justifyContent: 'flex-start', display: 'flex', flexDirection: 'row', fontSize: `calc(4px + 1vmin)`, }}><p style={{width:'auto', borderRadius: 10, paddingLeft: '2%', paddingRight: '2%', backgroundColor: '#D13939', color: 'white'}}>Schools</p><p style={{color: '#D13939'}} > must begin with <b>admin@</b></p></div>
  <div style={{width: '100%', height: 'auto',  justifyContent: 'flex-start', display: 'flex', flexDirection: 'row', fontSize: `calc(4px + 1vmin)`, }}><p style={{width:'auto', borderRadius: 10, paddingLeft: '2%', paddingRight: '2%', backgroundColor: '#D13939', color: 'white'}}>Entrepreneurs</p><p style={{color: '#D13939'}} > must end with <b>@learnershub </b></p></div>
  <div style={{width: '100%', height: 'auto',  justifyContent: 'flex-start', display: 'flex', flexDirection: 'row', fontSize: `calc(4px + 1vmin)`, }}><p style={{width:'auto', borderRadius: 10, paddingLeft: '2%', paddingRight: '2%', backgroundColor: '#D13939', color: 'white'}}>Academic</p><p style={{color: '#D13939'}} >  must end with <b>@schoolname </b></p></div>
  </div>
      )
  }

        return (
            <div>
               
                <div style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-around', paddingBottom: '5%'}}>
                <Button variant="contained" color="primary" onClick={() => setData('clicked')} >
  Watch Video
</Button> <p style={{padding: '3%'}}>or check below to read the guides on why, how and what you need to sign in</p>
                </div>

                
<div style={{width: '80vmin', display: 'flex'}}>


<div style={{display: 'flex', flexDirection:'column', backgroundColor: '#F8EDE3',  padding: '10%', borderRadius: 12, maxWidth: '100%', minWidth: '100%'}}>
<div style={{backgroundColor: 'lightgreen', display: 'flex', border: 1, alignSelf: 'center', alignItems: 'center', borderRadius: 5, alignContent: 'center', padding: '3%', width: '100%', justifyContent: 'center', flexDirection: 'column',}} >

<p> Student/ Alumni Login</p>
<Button variant="contained" color="primary" onClick={googleSignIn}>
        Google Login
      </Button>
      </div>

 <div style={{display: 'flex', alignSelf: 'center', alignItems: 'center', alignContent: 'center', padding: '3%', width: '100%', justifyContent: 'center', flexDirection: 'column',}} >
 <p> As a non-student</p>
 <div style={{display: 'flex', alignSelf: 'center', alignItems: 'center', alignContent: 'center', width: '100%', justifyContent: 'center', flexDirection: 'column',}}>
<TextField
          id="outlined-number"
          label="learners-hub email"
          type="email"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          placeholder='learners-hub email'
          required
          value = {learnershubemail}
         onChange={(e) => setLearnershubemail(e.target.value)}
          
        />
<p>Username:- {learnershubemail}</p>
<LoginInstructions/>
        <TextField
          id="outlined-password-input"
          label="Password"
          type="password"
          variant="outlined"
           placeholder='password'
           required
           value = {password}
         onChange={(e) => setPassword(e.target.value)}
         
         
        />


<Button
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={CustomSignIn}
      >
      Sign In
      </Button>
       
</div>

     

        </div>

        <div style={{width: '100%', height: 'auto',  justifyContent: 'flex-start', display: 'flex', flexDirection: 'row', fontSize: `calc(4px + 1vmin)`, }}><p style={{width:'auto', borderRadius: 10, paddingLeft: '2%', paddingRight: '2%', backgroundColor: '#D13939', color: 'white'}}>Errors</p><p style={{color: '#D13939'}} >  {errorMessages} <b>{errorCode}</b></p></div>

        </div>

        <div>
</div>
</div>
               
            </div>
        )
    }



    function IntroductionScreen () {
      const [video, setVideo] = useState('');

      console.log('introduction');


/*{ width >= 720 ?  <div style={{display:'flex',  padding: '1%', width: '50%' }}>
        <img src={admin} style={{objectFit: 'contain', width: '100%', height: height}} />
    </div>: null}
    */
function getWindowDimensions() {
        const { innerWidth: width, innerHeight: height } = window;
        return {
          width,
          height
        };
      }
      
       function useWindowDimensions() {
        const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
      
        useEffect(() => {
          function handleResize() {
            setWindowDimensions(getWindowDimensions());
          }
      
          window.addEventListener('resize', handleResize);
          return () => window.removeEventListener('resize', handleResize);
        }, []);
      
        return windowDimensions;
      }
      
      
      
      const { height, width } = useWindowDimensions();

return (
    <div style={{width: '100%'}} >

    <div className="Motto"  >

   <div className="MottoItem"  >
            <video src={connect} autoPlay loop={true} preload="metadata" style={{objectFit: 'contain', padding: '1%', width: '100%', height: height * 0.6 ,}} />
            <video src={explore} autoPlay loop={true} preload="metadata" style={{objectFit: 'contain', width: '100%', padding: '1%', height: height * 0.6 ,}} />
            <video src={improve} autoPlay loop={true} preload="metadata" style={{objectFit: 'contain', width: '100%', padding: '1%', height: height * 0.6 ,}} />

    </div>



    </div>

    <div className='HomeButtons' style={{ flexDirection: height > width ? "column" : "row" , textAlign: height > width  ? "center" : null, justifyContent: height > width ? null : "space-evenly" }} >
          <h4>What is Learners Hubs</h4>
          <h4>Why use Learners Hubs</h4>
          <h4> key features of Learners Hubs</h4>
   </div>

       <div>
         <div>
        
            <h1>What is Learners Hub</h1>
         
         </div>

         <div>
           <p> The Learners Hub is a content management platform that aims to bring students and Alumni closer to their educators and school management while steping up their Businesses with a free business account to reach more people  </p>
         </div>

         <Button variant="contained" color="primary" onClick={() => setVideo('clicked')} >
                 Watch Video
      </Button>

{video === ''? null : <p> you clicked the button</p>}
         <div>
            <h1>Why was Learners Hub created?</h1>
            <h6>Learners Hubs was created... </h6>
         </div>

         <div >

<div style={{display: 'flex', width: '100%', flexDirection: 'column', justifyContent: 'space-around', marginTop: '2%'}}>
    <div>    <h4 style={{ color: 'grey'}}>For Students</h4></div>
    <div className="videostyling">
<span className="line" ></span>
<span className="belowLine"></span>
</div>
    <div >
        <p style={{color: 'grey'}}>the learners hub was created to <b>connect</b> students like you to your school, your lecturers, and businesses giving you the opportunity to <b>explore</b> information around and beyond your physical reach, which eventually leads to your overall <b>improve</b>ment</p>     
    </div>

</div>

<div style={{display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'space-around', marginTop: '2%'}}>
    <div style={{padding: '2%', backgroundColor: 'grey'}}>
        <h4>For Businesses</h4>
    </div>
    
    <div style={{padding: '2%', backgroundColor: 'lightgrey'}}>
        <p>the learners hub was cerated to <b>connect</b> businesses like the one you are running currently to students, Alumni's and other busineses like yours, giving you the opportunity to <b>earn</b> money or fame, which eventually leads to the overall <b>improve</b>ment of your business career, something you will likely cherish </p>
    </div>
</div>

<div style={{display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'space-around', marginTop: '2%'}}>
<div style={{padding: '2%', backgroundColor: 'grey'}}>
<h4>For Schools</h4>
</div>

<div style={{padding: '2%', backgroundColor: 'lightgrey'}}>
<p>The learners hub was created to <b>connect</b> schools like the one you work for, or attended to past, present and future students, and even businesses giving you the oppportunity to <b>empower</b> people around and beyond your physical reach, which will eventually lead to your schools overall <b>improve</b>ment and reliablity </p>
</div>
</div>  
  
  </div>

  <div>
    <h1>Features Overview </h1>

  </div>

  <div>
  <h4>For Students</h4>
    <p>
hi guys
    </p>

    <h4>For Businesses</h4>
    <p>

    </p>

    <h4>For Schools</h4>
    <p>

    </p>
  </div>

   <TextField
          id="outlined-password-input"
          label="Password"
          type="password"
          variant="outlined"
           placeholder='password'
           required
           
         
         
        />

</div>
</div>
)
    }

    function SignUpScreen () {

            console.log('signin');
 const [visible, setVisible] = useState(true);
        const [learnershubemail, setLearnershubemail] = useState('');
        const [errors, setErrors] = useState(false);
        const [password, setPassword] = useState('');
      const [errorMessages, setErrorMessages] = useState('no errors');
      const [errorCode, setErrorCode] = useState('no errors');
      


  async function CustomSignIn () {

    firebase.auth().createUserWithEmailAndPassword(learnershubemail, password).catch(function(error) {
 // Handle Errors here.
 var errorCode = error.code;
 var errorMessage = error.message;
 // ...
 setErrorMessages(errorMessage);
 setErrorCode(errorCode);
});
  }



  
function LoginInstructions () {

    return(
  <div>
  <div style={{width: '100%', height: 'auto',  justifyContent: 'flex-start', display: 'flex', flexDirection: 'row', fontSize: `calc(4px + 1vmin)`, }}><p style={{width:'auto', borderRadius: 10, paddingLeft: '2%', paddingRight: '2%', backgroundColor: '#D13939', color: 'white'}}>Schools</p><p style={{color: '#D13939'}} > must begin with <b>admin@</b></p></div>
  <div style={{width: '100%', height: 'auto',  justifyContent: 'flex-start', display: 'flex', flexDirection: 'row', fontSize: `calc(4px + 1vmin)`, }}><p style={{width:'auto', borderRadius: 10, paddingLeft: '2%', paddingRight: '2%', backgroundColor: '#D13939', color: 'white'}}>Entrepreneurs</p><p style={{color: '#D13939'}} > must end with <b>@learnershub </b></p></div>
  <div style={{width: '100%', height: 'auto',  justifyContent: 'flex-start', display: 'flex', flexDirection: 'row', fontSize: `calc(4px + 1vmin)`, }}><p style={{width:'auto', borderRadius: 10, paddingLeft: '2%', paddingRight: '2%', backgroundColor: '#D13939', color: 'white'}}>Academic</p><p style={{color: '#D13939'}} >  must end with <b>@schoolname </b></p></div>
  </div>
      )
  }

        return (
            <div>
            <p>before you signup, please watch or read the information below the input fields</p>
            <h2>For students</h2>
            <p> Go to the login page to see the Google signin button</p>

            <h2>For Schools</h2>
            <p>send a message to any of learnershubs social media handke to get your login details</p>
                <div style={{display: 'flex', alignSelf: 'center', alignItems: 'center', alignContent: 'center', padding: '3%', width: '100%', justifyContent: 'center', flexDirection: 'column',}} >
 <h2> For Businesses</h2>
 <i>tutorials, public figures, government offices should also use this feature</i>
 <div style={{display: 'flex', alignSelf: 'center', alignItems: 'center', alignContent: 'center', width: '100%', justifyContent: 'center', flexDirection: 'column',}}>
<TextField
          id="outlined-number"
          label="learners-hub email"
          type="email"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          placeholder='learners-hub email'
          required
          value = {learnershubemail}
         onChange={(e) => setLearnershubemail(e.target.value)}
          
        />
<p>Username:- {learnershubemail}</p>
<LoginInstructions/>
        <TextField
          id="outlined-password-input"
          label="Password"
          type="password"
          variant="outlined"
           placeholder='password'
           required
           value = {password}
         onChange={(e) => setPassword(e.target.value)}
         
         
        />


<Button
        variant="contained"
        color="primary"
        
        onClick={CustomSignIn}
      >
      Sign In
      </Button>
       
</div>

     

        </div>

        <div style={{width: '100%', height: 'auto',  justifyContent: 'flex-start', display: 'flex', flexDirection: 'row', fontSize: `calc(4px + 1vmin)`, }}><p style={{width:'auto', borderRadius: 10, paddingLeft: '2%', paddingRight: '2%', backgroundColor: '#D13939', color: 'white'}}>Errors</p><p style={{color: '#D13939'}} >  {errorMessages} <b>{errorCode}</b></p></div>




        </div>

        

           
        );
    }
